import React, { lazy, Suspense } from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import { ShoppingCartSkeleton } from '../ShoppingCart/ShoppingCartSkeleton';
import { FormWrapperWithOrderSkeleton } from './FormWrapperWithOrder/FormWrapperWithOrderSkeleton';
import { CheckoutSteps } from './constants';
import { harmonizeLink } from './helpers';
const CheckoutForm = lazy(() => import('./CheckoutForm'));
const checkoutFormEditConfig = {
    emptyLabel: 'Checkout Form',
    isEmpty: () => false,
};
function CheckoutFormWrapper(props) {
    const step = harmonizeLink(window.location.hash).slice(1);
    const Skeleton = step === CheckoutSteps.CART ? (React.createElement(ShoppingCartSkeleton, null)) : (React.createElement(FormWrapperWithOrderSkeleton, { step: step }));
    return (React.createElement(Suspense, { fallback: !props.isInEditor ? Skeleton : null },
        React.createElement(CheckoutForm, { ...props })));
}
export default MapTo(AEM_FUNCTIONS.checkoutForm)(withTranslation(CheckoutFormWrapper, ['eInvoiceModel.labels']), checkoutFormEditConfig);
